import { getValue } from '../../utils/getValue'
import { AddressKey, AddressValue, AddressView, ScanAddress } from './styles'

export function SquaresAddresses({
  codendereco,
  rua,
  predio,
  nivel,
  apto,
  size,
  qt,
}) {
  return (
    <ScanAddress>
      {codendereco && (
        <AddressView size={size}>
          <AddressKey>Cód.</AddressKey>
          <AddressValue>{codendereco}</AddressValue>
        </AddressView>
      )}

      <AddressView size={size}>
        <AddressKey>Rua</AddressKey>
        <AddressValue>{rua}</AddressValue>
      </AddressView>

      <AddressView size={size}>
        <AddressKey>Préd</AddressKey>
        <AddressValue>{predio}</AddressValue>
      </AddressView>

      <AddressView size={size}>
        <AddressKey>Nv</AddressKey>
        <AddressValue>{getValue(nivel)}</AddressValue>
      </AddressView>

      <AddressView size={size}>
        <AddressKey>Apto</AddressKey>
        <AddressValue>{apto}</AddressValue>
      </AddressView>

      {qt && (
        <AddressView size={size}>
          <AddressKey>Qt</AddressKey>
          <AddressValue>{qt}</AddressValue>
        </AddressView>
      )}
    </ScanAddress>
  )
}
